<template>
    <div class="modal" :class="{'is-active': active}">
        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t('accept_modal_title') }}</p>
            </header>
            <section class="modal-card-body px-0 py-0">
                <table class="table is-striped is-hoverable is-fullwidth mb-0">
                    <thead>
                        <tr>
                            <th colspan="3" v-text="$t('my_availabilities')"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="clickable" :class="{'is-selected': selectedAvailability && selectedAvailability.id == availability.id}" v-for="availability in _.sortBy(fileredAvailabilities, ['date', 'time'])" @click.prevent="selectAvailability(availability)">
                            <th style="min-width: 125px; width: 125px;">{{ availability.date | momentFormat('YYYY-MM-DD', $t('availability_date_format')) }}</th>
                            <td style="width: 100%;">{{ timeSlots[availability.time].start + ' - ' + timeSlots[availability.time].end }}</td>
                            <td style="min-width: 125px; width: 125px;">
                                <span class="tag is-fullwidth is-success is-small" v-if="selectedAvailability && selectedAvailability.id == availability.id">
                                    <span class="icon"><i class="mdi mdi-check-circle"></i></span>
                                    {{ $t('selected') }}
                                </span>
                                <span class="tag is-fullwidth is-primary is-small" v-else>
                                    <span class="icon"><i class="mdi mdi-check-circle-outline"></i></span>
                                    {{ $t('select') }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                    <thead>
                        <tr>
                            <th colspan="3" v-text="$t('other_availabilities')"></th>
                        </tr>
                    </thead>
                    <tbody v-for="date in dates">
                        <tr v-if="! showEarlySlots && timeslotIsInFuture(date, 32)">
                            <td colspan="3" class="has-text-centered clickable" @click.prevent="toggleEarlySlots()">
                                <a href="#" class="is-size-7">{{ $t('show_early_slots') }}</a>
                            </td>
                        </tr>
                        <tr v-for="slot in _.filter(timeSlots, (time, key) => { return timeslotIsVisible(key) && timeslotIsAvailable(date, key) && timeslotIsInFuture(date, key) })" class="clickable" :class="{'is-selected': selectedDate == date && selectedTimeslot == slot}" @click.prevent="selectDateAndTimeslot(date, slot)">
                            <th style="min-width: 125px; width: 125px;">{{ date | momentFormat('YYYY-MM-DD', $t('availability_date_format')) }}</th>
                            <td style="width: 100%;">{{ slot.start + ' - ' + slot.end }}</td>
                            <td style="min-width: 125px; width: 125px;">
                                <span class="tag is-fullwidth is-success is-small" v-if="selectedDate == date && selectedTimeslot == slot">
                                    <span class="icon"><i class="mdi mdi-check-circle"></i></span>
                                    {{ $t('selected') }}
                                </span>
                                <span class="tag is-fullwidth is-primary is-small" v-else>
                                    <span class="icon"><i class="mdi mdi-check-circle-outline"></i></span>
                                    {{ $t('select') }}
                                </span>
                            </td>
                        </tr>
                        <tr v-if="! showLateSlots">
                            <td colspan="3" class="has-text-centered clickable" @click.prevent="toggleLateSlots()">
                                <a href="#" class="is-size-7">{{ $t('show_late_slots') }}</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" :disabled="isModalLoading" @click.prevent="close()">{{ $t('cancel_button_label') }}</button>
                <button class="button is-primary":class="{'is-loading': isModalLoading}" @click.prevent="confirm()">{{ $t('accept_modal_confirm_button_label') }}</button>
            </footer>
        </div>
    </div>
</template>

<script>
import helpers from '@/mixins/helpers'
import { store } from '@/store'
import moment from 'moment'

import appointmentInvitationRepository from '@/data/AppointmentInvitationRepository'
import timeSlotRepository from '@/data/TimeSlotRepository'

export default {
    name: 'accept-emergency',

    props: ['emergency', 'availabilities', 'active'],

    mixins: [helpers],

    data () {
        return {
            selectedAvailability: null,
            selectedDate: null,
            selectedTimeslot: null,
            isModalLoading: false,
            timeSlots: {},
            dates: [],
            showEarlySlots: false,
            showLateSlots: false,
            currentTimeslot: Math.floor((moment().hour() * 60 + moment().minute()) / 15)
        }
    },

    computed: {
        fileredAvailabilities() {
            return _.filter(this.availabilities, (availability, key) => {
                return availability.date != moment().format('YYYY-MM-DD') || availability.time > this.currentTimeslot
            })
        }
    },

    mounted() {
        this.setupDates()
        this.setupTimeSlots()
    },

    methods: {
        close () {
            if (! this.isModalLoading) {
                this.$emit('close')
                document.documentElement.classList.toggle('is-clipped', false)
            }
        },

        confirm () {
            this.isModalLoading = true

            if (this.selectedAvailability) {
                appointmentInvitationRepository.accept(this.emergency, this.selectedAvailability, this.doctor, this.offices[this.currentOffice], () => {
                    // Success
                    this.isModalLoading = false

                    this.close()

                    this.$dialog.alert({
                        title: this.$t('accepted_dialog_title'),
                        message: this.$t('accepted_dialog_message'),
                        hasIcon: true,
                        type: 'is-success',
                        onConfirm: () => {
                            this.$emit('accepted')
                        },
                        cancelText: this.$t('cancel_button_label'),
                        confirmText: this.$t('ok_button_label')
                    })
                }, (error) => {
                    // Error
                    this.isModalLoading = false

                    this.alertError(error.message)
                })
            } else if (this.selectedDate && this.selectedTimeslot) {
                timeSlotRepository.create(this.doctor, this.offices[this.currentOffice], this.selectedDate, this.selectedTimeslot.key, (timeSlot) => {
                    appointmentInvitationRepository.accept(this.emergency, timeSlot, this.doctor, this.offices[this.currentOffice], () => {
                        // Success
                        this.isModalLoading = false

                        this.close()

                        this.$dialog.alert({
                            title: this.$t('accepted_dialog_title'),
                            message: this.$t('accepted_dialog_message'),
                            hasIcon: true,
                            type: 'is-success',
                            onConfirm: () => {
                                this.$emit('accepted')
                            },
                            cancelText: this.$t('cancel_button_label'),
                            confirmText: this.$t('ok_button_label')
                        })
                    }, (error) => {
                        // Error
                        this.isModalLoading = false

                        this.alertError(error.message)
                    })
                }, (error) => {
                    this.isModalLoading = false

                    this.alertError(error.message)
                })
            } else {
                this.isModalLoading = false

                this.alertError(this.$t('nothing_selected'))
            }
        },

        selectAvailability(availability) {
            this.selectedDate = null
            this.selectedTimeslot = null
            this.selectedAvailability = availability
        },

        selectDateAndTimeslot(date, timeslot) {
            this.selectedAvailability = null
            this.selectedDate = date
            this.selectedTimeslot = timeslot
        },

        toggleEarlySlots() {
            this.showEarlySlots = ! this.showEarlySlots
        },

        toggleLateSlots() {
            this.showLateSlots = ! this.showLateSlots
        },

        setupDates() {
            for (var i = 0; i < 3; i++) {
                var date = moment().add(i, 'days').startOf('day').format('YYYY-MM-DD')
                this.dates.push(date)
            }
        },

        setupTimeSlots () {
            for (let i = 0; i < 96; i++) {
                var start = moment.duration(i * 15, 'minutes')
                var end = start.clone().add(15, 'minutes')
                this.timeSlots[i] = {
                    key: i,
                    start: moment.utc(start.asMilliseconds()).format(this.$t('time_format')),
                    end: moment.utc(end.asMilliseconds()).format(this.$t('time_format'))
                }
            }
        },

        timeslotIsAvailable (date, timeslot) {
            return (_.filter(this.availabilities, (availability, key) => {
                return availability.date == date && availability.time == timeslot
            })).length == 0
        },

        timeslotIsVisible (timeslot) {
            return this.showEarlySlots && this.showLateSlots ? true : (this.showEarlySlots ? timeslot < 80 : (this.showLateSlots ? timeslot > 32 : timeslot > 32 && timeslot < 80))
        },

        timeslotIsInFuture (date, timeslot) {
            return date != moment().format('YYYY-MM-DD') || timeslot > this.currentTimeslot
        }
    },

    watch: {
        active (newStatus) {
            this.selectedAvailability = null
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Doctor/AcceptEmergencyForm.vue